import React, {Component} from 'react'
import { LoadingIcon } from '../../Svg/Index.js'

class LoaderInline extends Component {

    render() {
        return (
            <div className={`c-loader-inline ${this.props.withClass}`}>
                <div className="c-loader-inline__inner">
                    <LoadingIcon />
                </div>
            </div>
        )
    }
}

export default LoaderInline